import React, { ReactElement, useEffect } from "react";
import { DataGrid, GridColDef, GridCellParams, GridRowParams, GridValueFormatterParams, GridValueGetterParams, GridSortModel, deDE, LocalizationV4 } from "@material-ui/data-grid";
import Tooltip from '@material-ui/core/Tooltip';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {
    Container,
} from "@material-ui/core";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
    getRoutergeraeteListe,
    selectRoutergeraeteListe,
    selectRoutergeraettypen,
    updateAktuellesRoutergeraet,
    routergeraetDummy,
    selectListLoading,
    selectSorting,
    setSorting
} from "./routergeraetSlice";
import { useStyles } from "./routergeraetStyles";
import { useMsal } from "@azure/msal-react";
import { routergeraet, routergeraettyp } from "../../../utils/apiTypes";
import { globalStyles } from "../../../assets/globalStyles";
import { alphaNumSort } from "../../../utils/utils";
import { useParams } from 'react-router';


export default function RoutergeraetGrid(): ReactElement {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();

    const { id } = useParams<{id: string | undefined}>();

    useEffect(() => {
        dispatch(getRoutergeraeteListe(id));
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const rows: routergeraet[] = useAppSelector(selectRoutergeraeteListe),
        routergeraetetypSelectList: routergeraettyp[] = useAppSelector(selectRoutergeraettypen),
        listLoading: boolean = useAppSelector(selectListLoading),
        sorting: GridSortModel = useAppSelector(selectSorting);



    const dataGridCols2: GridColDef[] = [
        {
            field: 'status', headerName: ' ', flex: 0.2, align: "center", renderCell: function status(params: GridCellParams) {
                return (<React.Fragment>
                    {params.getValue(params.id, 'zugeordnet') ?
                        <Tooltip title="Aktivem Messpunkt zugeordnet">
                            <FiberManualRecordIcon color="secondary" />
                        </Tooltip>
                        : (params.getValue(params.id, 'jemalsZugeordnet') ?
                            <Tooltip title="Aktivem Messpunkt zugeordnet gewesen">
                                <FiberManualRecordOutlinedIcon color="secondary" />
                            </Tooltip>
                            : "")}</React.Fragment>)
            },
            sortComparator: (_1, _2, param1, param2) => {
                const p1 = param1.api.getCellValue(param1.id, 'zugeordnet') ? 2 : param1.api.getCellValue(param1.id, 'jemalsZugeordnet') ? 1 : 0;
                const p2 = param1.api.getCellValue(param2.id, 'zugeordnet') ? 2 : param1.api.getCellValue(param2.id, 'jemalsZugeordnet') ? 1 : 0;
                return p2 - p1;
            }, filterable: false
        },
        { field: 'seriennummer', headerName: 'Seriennummer', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'herstellungsjahr', headerName: 'Herstellungsjahr', flex: 0.8 },
        { field: 'firmware', headerName: 'Firmware', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'macadresse', headerName: 'MAC Adresse', flex: 0.8, sortComparator: alphaNumSort },
        {
            field: 'inbetriebnahmedatum', headerName: 'Inbetriebnahmedatum', flex: 1, valueFormatter: (params: GridValueFormatterParams) => {
                const inbetriebnahmedatumO = params.getValue(params.id, 'inbetriebnahmedatum');
                if (inbetriebnahmedatumO === null)
                    return "";
                const dateConvert = new Date(inbetriebnahmedatumO ? inbetriebnahmedatumO.toString() : "");
                return (dateConvert).toLocaleDateString('de-DE')
            }, filterable: false
        },
        { field: 'wartungsintervall', headerName: 'Wartungsintervall', flex: 1, sortComparator: alphaNumSort },
        { field: 'zeitsynchronisationsart', headerName: 'Zeitsynchronisationsart', flex: 1 },
        {
            field: 'hersteller', headerName: 'Hersteller', flex: 0.8, valueGetter: (params: GridValueGetterParams) => {
                return routergeraetetypSelectList.length == 0 ? "Wird geladen..." : (routergeraetetypSelectList.find((x: routergeraettyp) => x.id == params.getValue(params.id, 'typ'))?.hersteller);
            }
        },
        {
            field: 'routergereattyp', headerName: 'Typ', flex: 0.8, valueGetter: (params: GridValueGetterParams) => {
                return routergeraetetypSelectList.length == 0 ? "Wird geladen..." : (routergeraetetypSelectList.find((x: routergeraettyp) => x.id == params.getValue(params.id, 'typ'))?.typ);
            }
        },
        { field: 'ipadresse', headerName: 'IP-Adresse', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'subnetzmaske', headerName: 'Subnetzmaske', flex: 0.8, sortComparator: alphaNumSort }
    ]


    return (
        <Container maxWidth={false} className={classes.root}>
            <div style={{ height: "50vh", width: '100%' }}>
                <DataGrid
                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                    disableColumnMenu={false}
                    disableColumnSelector={true}
                    columns={dataGridCols2}
                    rows={rows}
                    sortModel={sorting}
                    onSortModelChange={(model) => setSorting(model.sortModel)}
                    onRowClick={(param: GridRowParams) => {
                        let mt = routergeraetDummy;
                        const temp = rows.find(mst => mst.id == (param.row.id as number))
                        if (temp)
                            mt = temp;
                        dispatch(updateAktuellesRoutergeraet(mt));
                    }} loading={listLoading} />
            </div>
        </Container >
    );
}
